import { z } from "zod";
import { EMAIL_ID } from "./consts";

export const schema = z.object({
  [EMAIL_ID]: z
    .string()
    .min(1, "Please fill contact email")
    .email("Invalid email."),
});

export type formValues = z.infer<typeof schema>;
